import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <h3>About Us</h3>
          <p>
            Shriram Cabs is a trusted cab service provider committed to delivering safe, affordable, and reliable transport solutions. Whether you're traveling locally or planning an outstation journey, we ensure a comfortable ride every step of the way. <br />Business Relationship
Our Company Name:- SHRIRAM TOURS AND TRAVELS
Owner Name:- Gopichand Ramraoji Shinde
<a href="https://shriramcabsnagpur.com/ ">https://shriramcabsnagpur.com/ </a>Website Is Collecting data for SHRIRAM TOURS AND TRAVELS. And SHRIRAM TOURS AND TRAVELS he is a owner or Proprietor He Is owned this site and Business.
          </p>
        </div>
        <div className="footer-middle">
          <h3>Quick Links</h3>
          <nav className="links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Route</Link>
            <Link to="/contact">Contact us</Link>
          </nav>
        </div>
        <div className="footer-right">
          <h3>Contact Us</h3>
          <p>Email:  shriramcabs@gmail.com</p>
          <p>Phone:+91 7798573786</p>
          <p>Address:Daw, Mohammed Shafiq, Qureshi road Nagpur, plot number 115, Prashant Nagar, Police Line Takli, Nagpur, Maharashtra 440013</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} <a style={{textDecoration:"none"}} href="https://royalswebtechpvtltd.com" target="_blank">Royals Webtech</a>. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
